<script lang="ts" setup>
import { useAppStore } from "@/store/app.store";
import { computed } from "vue";
import type { TruckRoute } from "@/api/trucks/dto/truck.dto";

const props = defineProps<{
  route: TruckRoute;
}>();

const appStore = useAppStore();

const dispatcher = computed(() => {
  return appStore.dispatchers.find((dispatcher) => dispatcher.id === props.route.travelOrders[0].order.bookedBy);
});
</script>

<template>
  <div>
    <span v-if="dispatcher" class="text-primary mt-2">
      {{ dispatcher.name }}
    </span>

    <span v-else class="text-center text-grey-darken-2 font-size-24"> - </span>
  </div>
</template>

<style lang="scss" scoped></style>
